import { Box, Button, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';
import { Link } from 'react-router-dom';
import forbidden from '../assets/img/forbidden.png';

export const NonPermission = () => {
  const t = useTranslate();
  return (
    <Box component={'section'} sx={{ mt: '20px', textAlign: 'center' }}>
      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
        gap={4}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '80px',
        }}
      >
        <img
          width={400}
          src={forbidden}
          alt="No puedes acceder, no tienes permisos"
        />

        <Typography
          variant="h6"
          sx={{
            textAlign: 'center',
            fontSize: '24px',
            fontWeight: '600',
          }}
        >
          {t('forbidden.title')}
        </Typography>
        <Box>
          <Typography
            variant="body1"
            sx={{
              maxWidth: '500px',
              margin: '0 auto',
              textAlign: 'center',
              fontSize: '16px',
            }}
          >
            {t('forbidden.subtitle')}
          </Typography>
        </Box>
        <Button variant="contained" component={Link} to="/">
          <span> {t('forbidden.btnText')}</span>
        </Button>
      </Box>
    </Box>
  );
};
